import { GetStaticProps, GetStaticPropsContext, NextPage } from 'next'

import { GetProps } from '~/utils/pageWrapper/types'

import { getStaticPropsWrapper } from '~/utils/pageWrapper/staticPageWrapper'

import { getFaqs, getRunningQueriesThunk } from '~/redux/apis/static-page-api'
import Faq from '~/static-pages/faq/pages/Faq.page'
import { DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import appConfig from '~/config/app'
import { AppLanguage } from '~/types/locale'

const FAQPage: NextPage = () => {
  return <Faq />
}

const getProps: GetProps =
  (store) =>
  async ({ locale }: GetStaticPropsContext) => {
    store.dispatch(getFaqs.initiate({ language: locale as AppLanguage }))
    await Promise.all(store.dispatch(getRunningQueriesThunk()))
    return {
      props: {
        namespaces: DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES,
      },
      revalidate: appConfig.isPublicWebsite ? 3600 : 60,
    }
  }

export const getStaticProps: GetStaticProps = getStaticPropsWrapper(getProps)

export default FAQPage
